import { ClientDevData } from '../typings/dev';

export const DO_FAKE_AUTH = 'DO_FAKE_AUTH';
export type DO_FAKE_AUTH = typeof DO_FAKE_AUTH;

export interface DoFakeAuth {
    type: DO_FAKE_AUTH;
    login: string;
}

export function doFakeAuth(login: string): DoFakeAuth {
    return {
        type: DO_FAKE_AUTH,
        login
    };
}

export const SWITCH_SHOW_CAPTCH_STATE = 'SWITCH_SHOW_CAPTCH_STATE';
export type SWITCH_SHOW_CAPTCH_STATE = typeof SWITCH_SHOW_CAPTCH_STATE;

export interface SwitchShowCaptchState {
    type: SWITCH_SHOW_CAPTCH_STATE;
}

export function switchShowCaptchState(): SwitchShowCaptchState {
    return {
        type: SWITCH_SHOW_CAPTCH_STATE
    };
}

export const SWITCH_DUMP_VARS_STATE = 'SWITCH_DUMP_VARS_STATE';
export type SWITCH_DUMP_VARS_STATE = typeof SWITCH_DUMP_VARS_STATE;

export interface SwitchDumpVarsState {
    type: SWITCH_DUMP_VARS_STATE;
}

export function switchDumpVarsState(): SwitchDumpVarsState {
    return {
        type: SWITCH_DUMP_VARS_STATE
    };
}

export const FETCH_CLIENT_DEV_INFO = 'FETCH_CLIENT_DEV_INFO';
export type FETCH_CLIENT_DEV_INFO = typeof FETCH_CLIENT_DEV_INFO;

export interface FetchClientDevInfoAction {
    type: FETCH_CLIENT_DEV_INFO;
}

export function fetchClientDevInfoAction(): FetchClientDevInfoAction {
    return {
        type: FETCH_CLIENT_DEV_INFO
    };
}

export const UPDATE_CLIENT_DEV_INFO = 'UPDATE_CLIENT_DEV_INFO';
export type UPDATE_CLIENT_DEV_INFO = typeof UPDATE_CLIENT_DEV_INFO;

export interface UpdateClientDevInfoAction {
    type: UPDATE_CLIENT_DEV_INFO;
    clientDev: ClientDevData;
}

export function updateClientDevInfo(
    clientDev: ClientDevData
): UpdateClientDevInfoAction {
    return {
        type: UPDATE_CLIENT_DEV_INFO,
        clientDev
    };
}

export type DevelopmentToolsAction =
    | DoFakeAuth
    | SwitchDumpVarsState
    | SwitchShowCaptchState
    | FetchClientDevInfoAction
    | UpdateClientDevInfoAction;
